import { makeStyles, Theme } from "@material-ui/core/styles";

const styles = makeStyles((theme: Theme) => ({
  icons: {
    position: 'relative',
    top: '6px',
  },
  availabilityFilterLabel: {
    textTransform: 'none',
  },
  availabilityButton: {
    cursor: 'text',
    fontSize: 16,
    color: theme.palette.constrastGreyDark.main,
    height: 41,
    float: 'left',
    marginBottom: 0,
    backgroundColor: '#f7f9fa',
  },
  divFilters: {
    display: 'flex',
    justifyContent: 'flex-end',
    '& > button': {
      marginRight: '50px',
    },
    '& > div': {
      marginRight: '50px',
    },
  },
  divGroups: {
    marginLeft: '27px',
  },
  divItems: {
    marginLeft: '80px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  buttonApply: {
    height: '45px',
  },
  searchButtonPopover: {
    padding: '7px',
    transform: 'translate(-8px, -16px)!important',
    width: '395px',
    maxHeight: '350px',
  },
  flexSpaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  alignCenter: {
    alignItems: 'center',
  },
}));

export default styles;
